import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputLayout, useFormInputLayout, } from '../FormInputLayout/FormInputLayout';
import { BaseSelect } from './BaseSelect';
const Name = 'FormInputSelect';
export const FormInputSelect = props => {
    const { control } = useFormContext();
    const { className, dependentFields, disabled, hint, id, label, labelledBy, required, name, componentProps: { multi, options, placeholder, ...otherComponentProps }, } = useFormInputLayout(props);
    if (!id)
        return null;
    return (_jsx(Controller, { control: control, name: name, rules: {
            deps: dependentFields,
        }, render: ({ field: { name, onChange, value } }) => {
            return (_jsx(FormInputLayout, { className: className, "data-component": Name, disabled: disabled, fieldId: id, hint: hint, label: label, labelledBy: labelledBy, name: name, required: required, renderInput: ({ isValid, labelId }) => (_jsx(BaseSelect, { id: id, labelId: labelId, multi: multi, options: options, value: value, placeholder: placeholder, onChange: onChange, "data-invalid": !isValid, "data-disabled": disabled, ...otherComponentProps })) }));
        } }));
};
